import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PowerBiDashboardType } from '@/api/powerbi'

type PowerBiFilterKey = string

interface PowerBiFilterState {
  bookmarks: Record<PowerBiFilterKey, string>
  getBookmark: (key: PowerBiFilterKey) => string | undefined
  setBookmark: (key: PowerBiFilterKey, state: string) => void
  clearBookmark: (key: PowerBiFilterKey) => void
}

export const usePowerBiFilterStore = create<PowerBiFilterState>()(
  persist(
    (set, get) => ({
      bookmarks: {},

      getBookmark: key => get().bookmarks[key],

      setBookmark: (key, state) =>
        set(prev => ({
          bookmarks: { ...prev.bookmarks, [key]: state },
        })),

      clearBookmark: key =>
        set(prev => {
          if (!(key in prev.bookmarks)) return prev
          const next = { ...prev.bookmarks }
          delete next[key]
          return { bookmarks: next }
        }),
    }),
    { name: 'powerbi-filters' }
  )
)

export function makePowerBiFilterKey(
  userId: string | null | undefined,
  reportType: PowerBiDashboardType,
  reportId: string | null | undefined
): PowerBiFilterKey | undefined {
  if (!userId || !reportId) return undefined
  return `${userId}:${reportType}:${reportId}`
}
